// Generated by portal/sdk/scripts/build.js before the core SDK is bundled.
module.exports = "/comments/milla-comments.0c9fd731a44d.js";
